import { useEffect, useRef, useState } from "react";

import { obterPosicoes } from "../api/client";
import type { PositionPoint } from "../types";

/**
 * Rasto GNSS da boia selecionada, no intervalo escolhido.
 *
 * Separado do `useHistory` de propósito: alimenta o **mapa**, não os gráficos, e
 * é só da boia selecionada. Seis rastos sobrepostos num pentágono de 35 m de
 * raio não se distinguiriam uns dos outros.
 *
 * Uma falha aqui devolve lista vazia sem propagar erro: o mapa continua a
 * mostrar os marcadores, que é a informação principal. O rasto é acessório.
 */
export function usePositions(code: string | null, de: Date, ate: Date): PositionPoint[] {
  const [pontos, setPontos] = useState<PositionPoint[]>([]);
  const abortar = useRef<AbortController | null>(null);

  const deMs = de.getTime();
  const ateMs = ate.getTime();

  useEffect(() => {
    if (code === null) {
      setPontos([]);
      return;
    }

    abortar.current?.abort();
    const controlo = new AbortController();
    abortar.current = controlo;

    void (async () => {
      try {
        const r = await obterPosicoes(code, new Date(deMs), new Date(ateMs), controlo.signal);
        setPontos(r.itens);
      } catch {
        if (!controlo.signal.aborted) setPontos([]);
      }
    })();

    return () => controlo.abort();
  }, [code, deMs, ateMs]);

  return pontos;
}
